import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip_info = _resolveComponent("tooltip-info")!
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_project_proposal_skills_field = _resolveComponent("project-proposal-skills-field")!
  const _component_autocomplete = _resolveComponent("autocomplete")!
  const _component_VJoyTag = _resolveComponent("VJoyTag")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_BriefHubStepLayout = _resolveComponent("BriefHubStepLayout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BriefHubStepLayout, null, {
      right: _withCtx(() => [
        _createVNode(_component_tooltip_info, {
          icon: "megaphone",
          title: _ctx.$msg('customer.brief.form.tooltip.tip')
        }, {
          content: _withCtx(() => [
            _createElementVNode("p", {
              innerHTML: _ctx.$msg('customer.brief.form.freelancer.skills.tooltip.v3')
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.freelancer.skills.title.v2')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VJoyLabel, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.exec.form.freelancer.skills.skills.label')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_project_proposal_skills_field, {
          "initial-skills": $setup.skills,
          category: $setup.selectedCategory,
          "job-title": $setup.jobTitle,
          "freelancer-skills-service": $setup.freelancerSkillsService,
          onUpdate: $setup.updateSkills,
          onSuggestedSkillsFetched: $setup.initializeComponent
        }, null, 8, ["initial-skills", "category", "job-title", "freelancer-skills-service", "onUpdate", "onSuggestedSkillsFetched"]),
        _createVNode(_component_VJoyLabel, {
          "optional-label": _ctx.$msg('generic.form.optional.mention')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.freelancer.skills.languages.title')), 1)
          ]),
          _: 1
        }, 8, ["optional-label"]),
        _createVNode(_component_autocomplete, {
          "autocomplete-service": $setup.languagesService,
          "clear-search-after-selection": "",
          placeholder: _ctx.$msg('customer.brief.form.freelancer.skills.languages.placeholder'),
          label: "label",
          "onUpdate:modelValue": $setup.languageValueChanged
        }, {
          default: _withCtx(({option}) => [
            _createTextVNode(_toDisplayString(option.label), 1)
          ]),
          _: 1
        }, 8, ["autocomplete-service", "placeholder", "onUpdate:modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_VJoyWrapper, { "row-gap": "4" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languages, (language, index) => {
                return (_openBlock(), _createBlock(_component_VJoyTag, {
                  key: `language-${language.code}`,
                  variant: "secondary",
                  removable: true,
                  label: language.label,
                  onRemove: ($event: any) => ($setup.removeLanguage(index))
                }, null, 8, ["label", "onRemove"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}